import { VariationImageType } from "../productTypes";

function safeJsonParse(value: unknown) {
    if (typeof value !== "string") return value;

    let text = value.trim();

    try {
        return JSON.parse(text);
    } catch { }

    // Remove aspas simples externas
    if (text.startsWith("'") && text.endsWith("'")) {
        text = text.slice(1, -1);
    }

    // Corrige aspas duplicadas
    text = text.replace(/""/g, '"');

    try {
        return JSON.parse(text);
    } catch {
        return null; // ou lance um erro
    }
}

function buildImageUrl(path: string, imgsuffix: string): string {
    const isS3Image =
        path.split("://")[1] === "s3.amazonaws.com/img.ninegrid.com";
    return isS3Image ? `${path}/${imgsuffix}` : path;
}

function isImageAlreadyAdded(
    variations: VariationImageType[],
    imageUrl: string,
): boolean {
    return variations.some((variation) => variation.image === imageUrl);
}

export { safeJsonParse, buildImageUrl, isImageAlreadyAdded };